import { h } from 'preact';

import LazyBackground from '../lazy-background';

import { getGlyph } from '../glyphs';

const Welcome = (props) => {
	return (
		<div className="welcome">
			<LazyBackground image={'assets/splash-min.jpg'} overlay={true} />
			{ getGlyph('logo') }
			<div className="content">
				<h2>How does your relationship with water impact your daily life?</h2>
				<h3>See how you compare in Moen's water census survey.</h3>
			</div>
			<div className="cta">
				<button onClick={ () => props.next() }>Take the Survey</button>
				<div className="line"></div>
			</div>
		</div>
	);
}

export default Welcome;



// WEBPACK FOOTER //
// ./components/welcome/index.js